import { atom } from 'jotai';

export const menuOverlayAtom = atom<JSX.Element | string>('');
